import { render } from "./ActivityElement.vue?vue&type=template&id=5cbfb257"
import script from "./ActivityElement.vue?vue&type=script&lang=js"
export * from "./ActivityElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__